/* eslint-disable max-lines */
/* eslint-disable sort-imports */
/* eslint-disable camelcase */
import $ from 'jquery';
import ko from 'knockout';
import SearchPageViewModel from './searchpageviewmodel.js';
import bloomReach from '../shared/bloomreach.js';
import buyItAgain from './buyitagain.js';
import ccChart from '../../colicare/colicarechart.js';
import collapsibleList from './collapsiblelist.js';
import comparison from './productcomparison/comparison.js';
import facets from './facets.js';
import pagination from './pagination.js';
import productRecommendations from './productrecommendations.js';
import productRecommendationsBase from '../recommendations/productrecommendations';
import ratingStarSelector from './ratingstarselector.js';
import searchData from './searchdata.js';
import smartSuggestions from './smartsuggestions.js';
import {productsOnPage} from '../../vendor/googletagmanager/events.js';
import lazyLoadVideo from '../../lazyloadvideo.js';
import {returnsModalEventListener} from '../shared/returnsmodal.js';
import toggleTabView from './tabs';
import searchBanners from './categorysearchbanners.js';
import wishlistToggle from './wishlist/index.js';

const searchPage = {
    _restrictFacetValuesToThreshold: function () {
        $('[data-threshold]').each(function (index, list) {
            var $list = $(list),
                threshold = $list.data('threshold'),
                label = $list.data('label');

            collapsibleList($list, threshold, label);
        });
    },
    _initializeSort: function (dataManager) {
        var sort = function (e) {
            var sort = e.target.value,
                data = dataManager.get();

            if (data.Start > 0) {
                data.Start = 0;
            }

            data.Sort = sort;

            dataManager.set(data);
        };

        $('.searchSortFilter').on('change', sort.bind(this));
    },
    _initializePagination: function (dataManager) {
        var data = dataManager.get(),
            currentPage = Math.floor(data.Start / data.Size) + 1;

        function move(start) {
            data.Start = start;
            dataManager.set(data);
        }

        $('.pagelist .previous, .pagelist .next')
            .on('click', function (e) {
                e.preventDefault();

                if ($(e.target).hasClass('previous')) {
                    move((currentPage - 2) * data.Size);
                } else if ($(e.target).hasClass('next')) {
                    move(currentPage * data.Size);
                }
            });

        $('.pagelist')
            .on('click', '.pageNumbers', function (e) {
                e.preventDefault();
                move((+e.target.innerText - 1) * data.Size);
            })
            .each(function (index, list) {
                pagination($(list), currentPage);
            })
            .removeClass('jsHide');
    },
    _getOpenFacetIDs: function (element) {
        return element
            .children()
            .filter(function (index, element) {
                // Add opened lists
                return $(element).data('opened');
            })
            .map(function (index, element) {
                // Add the ID of this opened list
                return $(element).attr('id');
            });
    },
    _openFacetsByIDs: function (ids) {
        ids.each(function (key, val) {
            $('#' + val).attr('data-opened', 'true');
        });
    },
    _refineSearch: function (requestData) {
        var searchUrl = '/search/SearchByParameter?parameters=' + encodeURIComponent(JSON.stringify(requestData)),
            $newDom,
            $newProductGrid,
            $newFacets,
            originalFilterCount;

        if (this.refineSearchRequest !== null && typeof this.refineSearchRequest !== 'undefined') {
            this.refineSearchRequest.abort();
            this.refineSearchRequest = null;
        }

        originalFilterCount = $('#crumbList a').length;

        this.refineSearchRequest = $.ajax({url: searchUrl, dataType: 'html'}).done(
            function (htmlString) {
                $newDom = $(htmlString);
                $newProductGrid = $newDom.find('#search-display');

                var ids = this._getOpenFacetIDs($('#facetedSearch')),
                    currentFilterCount = $newProductGrid.find('#crumbList a').length;

                if ($newProductGrid.length) {
                    $newProductGrid.find('.lazy').each(function (index, item) {
                        $(item).addClass('lazyLoaded').attr('src', $(item).data('src'));
                    });
                    $newFacets = $newDom.find('#facetedSearch');
                    $('#search-display').replaceWith($newProductGrid);
                    $('#facetedSearch').replaceWith($newFacets);

                    this._updatePage();
                    this._updateFilterStatus(originalFilterCount, currentFilterCount);
                    this._openFacetsByIDs(ids);
                    this._restrictFacetValuesToThreshold();

                    $('html, body').animate({
                        scrollTop: $('#search-display').offset().top
                    });

                    if ($('#product-grid').length && $('#compareBar').length) {
                        this._initializeComparisonChart();
                    }

                    history.replaceState(requestData, document.title, searchUrl);
                } else {
                    smartPak.page.redirectToUrl(searchUrl);
                }
            }.bind(this)
        );
    },
    _updateFilterStatus: function (originalFilterCount, currentFilterCount) {
        $('#searchCrumbStatus').html(
            originalFilterCount < currentFilterCount
                ? 'Filter has been added to your selection'
                : 'Filter has been removed from your selection'
        );
    },
    _initializeViewAll: function (dataManager) {
        let id = 0;

        $('.pageListShowAll')
            .each(function (index, element) {
                const labelledby = `viewall-${id}`;

                element.id = labelledby;
                element.setAttribute('aria-labelledby', `${labelledby} h1Title`);
                id++;
            })
            .on('click', function (e) {
                e.preventDefault();

                var data = dataManager.get();

                data.Size = 200;
                data.Start = 0;

                dataManager.set(data);
            });
    },
    _shouldHideNewProductTags: function (dataManager) {
        var data = dataManager.get(),
            EXCLUDED_CATEGORY_IDS = [
                '811',
                '421',
                '283',
                '763',
                '772',
                '695',
                '764',
                '286',
                '1603',
                '539',
                '540',
                '541',
                '698',
                '699',
                '768',
                '1213',
                '1303',
                '1666',
                '1854',
                '1855',
                '1856',
                '1857',
                '1858',
                '1859',
                '1860',
                '1861',
                '1862',
                '1863',
                '1865',
                '1866',
                '1867',
                '1869',
                '1870',
                '1871',
                '1872',
                '1873',
                '1874',
                '1875',
                '1876',
                '1877',
                '1878',
                '1879',
                '1880',
                '1881',
                '1882',
                '1883',
                '1884',
                '1885',
                '1886',
                '1887'
            ];

        return EXCLUDED_CATEGORY_IDS.some(function (item) {
            return item === data.Query;
        });
    },
    _showSpecificPerksMessaging: function () {
        var hasPromo = smartPak.cdProfileCookie.hasSmartPerksPromo,
            isEligible = smartPak.smartPrimeCookie.PerksEligible,
            $active = $('.active'),
            $inactive = $('.inactive'),
            $ineligible = $('.ineligible');

        if (hasPromo === 'True' && isEligible === 'True') {
            $active.removeClass('jsHide');
        }

        if (hasPromo !== 'True' && isEligible === 'True') {
            $inactive.removeClass('jsHide');
        }

        if (isEligible !== 'True') {
            $ineligible.removeClass('jsHide');
        }
    },
    _getSearchTerm: function (dataManager) {
        const data = dataManager.get();

        if (data.Type && data.Type === 'category') {
            const categoryBanner = document.querySelector('.cat-banner-header');
            const pageName = document.querySelector('#categoryTitle #h1Title');
            
            return pageName?.innerText || categoryBanner?.innerText || '';
        }
        return data.Query;
    },
    _getProductsFromPage: function () {
        return Array.from(document.querySelectorAll('#product-grid [data-productid]')).map(element => {
            return {
                name: element.dataset.productName.trim(),
                productClassId: +element.dataset.productid,
                itemId: +element.dataset.productid + 10000
            };
        });
    },
    _getProductIdsFromPage: function () {
        return $.map($('#product-grid').find('[data-productid]'), function (element) {
            return +element.dataset.productid;
        });
    },
    _setRecommendations: function (response, ids) {
        productRecommendations.init(response.supplementWizardResults);
        if (smartPak.cdProfileCookie && smartPak.cdProfileCookie.qualifiesForSuggestions) {
            smartSuggestions.init(response.smartSuggestions, ids);
        }
    },
    _updatePage: function () {
        var data = this.dataManager.get(),
            ids,
            products;

        const $gridInterrupters = document.querySelectorAll('#product-grid .interrupter [data-ids][data-title]');

        if ($gridInterrupters) {
            import('./gridinterrupters.js').then(({ default: gridinterrupters }) => gridinterrupters([...$gridInterrupters]));
        }

        this._initializeSort(this.dataManager);
        this._initializePagination(this.dataManager);
        this._initializeViewAll(this.dataManager);
        facets.init(this.dataManager);
        ratingStarSelector.init();
        smartPak.recentlyViewedProducts._waitForContainer(
            '.searchReviewStars',
            smartPak.recentlyViewedProducts._showBvReviewStars
        );
        ccChart.updateChartPrices();
        this._showSpecificPerksMessaging();


        const params = new URLSearchParams(location.search);
        const initialHash = params.get('type') === 'content-term' ? '#bloomreachContentResults' : undefined;

        toggleTabView(document.querySelectorAll('.productCompareResults'), initialHash);

        if (this._shouldHideNewProductTags(this.dataManager)) {
            $('.new-product-badge').hide();
        }

        products = this._getProductsFromPage();

        if (data.Type === 'keyword' || data.Type === 'category') {
            const searchPageViewModel = new SearchPageViewModel(this._getSearchTerm(this.dataManager), products);
            ko.applyBindings(searchPageViewModel, document.getElementById('bloomreachContentResults'));
        }

        wishlistToggle();

        productsOnPage(products);

        ids = products.map(product => product.productClassId);

        if (ids && ids.length) {
            Promise.all([productRecommendationsBase.get(ids), buyItAgain.getProductResults()]).then(responses => {
                this._setRecommendations(responses[0], ids);
                buyItAgain.processResults(responses[1]);
            });
        }
    },
    _initializeComparisonChart: function () {
        comparison();
    },
    init: function () {
        this.dataManager = searchData(window.requestData, this._refineSearch.bind(this));

        this._updatePage();
        this._restrictFacetValuesToThreshold();

        bloomReach.init(document.querySelector('.BRRelatedProducts'), '.br-sf-widget', 4);

        if (window.searchBannersByCategory) {
            searchBanners(window.searchBannersByCategory, smartPak.smartPrimeCookie?.PerksEligible === 'True');
        }

        if (window.searchBannersByTerm) {
            searchBanners(window.searchBannersByTerm, smartPak.smartPrimeCookie?.PerksEligible === 'True');
        }

        if ($('#product-grid').length && $('#compareBar').length) {
            this._initializeComparisonChart();
        }

        lazyLoadVideo();
        returnsModalEventListener();        
    }
};

export default searchPage;
